// A butterfly, modelled facing +X: a dark body between two flat wing blobs.
// Ported 1:1 from age-of-mcp's classic butterfly.ts, whose four variants pick
// a wing colour deterministically per creature.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Wing colours — one per variant, picked deterministically per creature.
const WINGS = ["#f4a3c4", "#ffd35e", "#a0c8ff", "#ffb454"];

function partsFor(variant: number): Part[] {
  const wing = WINGS[variant % WINGS.length]!;
  return [
    { geometry: new THREE.BoxGeometry(0.013, 0.008, 0.045),
      color: "#2a2018", position: [0, 0.02, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.028, 0),
      color: wing, position: [0, 0.02, 0.028], scale: [1.1, 0.16, 1] },
    { geometry: new THREE.IcosahedronGeometry(0.028, 0),
      color: wing, position: [0, 0.02, -0.028], scale: [1.1, 0.16, 1] },
  ];
}

export const butterfly = defineModel({
  id: "butterfly",
  batchId: "standard",
  name: "Butterfly",
  tags: ["creature","butterfly","low-poly","age-of-mcp","classic"],
  summary: "Low-poly butterfly.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => partsFor(0) },
    { id: "variant-1", label: "Variant 2", parts: () => partsFor(1) },
    { id: "variant-2", label: "Variant 3", parts: () => partsFor(2) },
    { id: "variant-3", label: "Variant 4", parts: () => partsFor(3) },
  ],
  animations: [],
});
